<template>
    <!-- 耕雲導師解惑录 -->
    <div class="taoist">
        <div v-for="(item,index) in content" :key="index">
            <div class="flex-between title">
                <div class="titleLeft oneLine">{{item.cate_name}}</div>
<!--                <div-->
<!--                    v-show="item.lists.length>3"-->
<!--                    class="expand flex-start"-->
<!--                    @click="changShowList(index)"-->
<!--                >-->
<!--                    &lt;!&ndash; 展开收起按钮 &ndash;&gt;-->
<!--                    <div v-if="!contentStatus[index]" class="flex-center openBtn">-->
<!--                        <div>{{$t('downBtn')}}</div>-->
<!--                        <div class="down">-->
<!--                            <img src="../../static/img/down.png" alt />-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div v-if="contentStatus[index]" class="flex-center openBtn">-->
<!--                        <div>{{$t('upBtn')}}</div>-->
<!--                        <div class="down">-->
<!--                            <img src="../../static/img/up.png" alt />-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
            <!-- 二级列表 -->
          <div>
            <div
                class="content oneLine"
                @click="linkToArticleDetail(item1)"
                v-for="(item1,index1) in item.lists"
                :key="index1"
            >{{index1+1}}、{{item1.news_title}}</div>
          </div>
<!--            <div v-if="item.lists.length<=3 || contentStatus[index]">-->
<!--                <div-->
<!--                    class="content oneLine"-->
<!--                    @click="linkToArticleDetail(item1)"-->
<!--                    v-for="(item1,index1) in item.lists"-->
<!--                    :key="index1"-->
<!--                >{{index1+1}}、{{item1.news_title}}</div>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--                <div class="content oneLine" @click="linkToArticleDetail(item.lists[0])">{{1}}、{{item.lists[0].news_title}}</div>-->
<!--                <div class="content oneLine" @click="linkToArticleDetail(item.lists[1])">{{2}}、{{item.lists[1].news_title}}</div>-->
<!--                <point></point>-->
<!--                <div-->
<!--                    class="content oneLine"-->
<!--                    @click="linkToArticleDetail(item.lists.length-1)"-->
<!--                >{{item.lists.length}}、{{item.lists[item.lists.length-1].news_title}}</div>-->
<!--            </div>-->
            <barF5></barF5>
        </div>
    </div>
</template>

<script>
import point from "../../components/point";
import barF5 from "../../components/barF5";
export default {
    name: "",
    components: {
        point,
        barF5
    },
    props: ["content", "title"],
    data() {
        return {
            contentStatus: [false, false, false], //控制展开和结束
            // content: [
            //     {
            //         id: 39,
            //         cate_name: "耕云导师在禅宗典籍上的开示",
            //         lists: [
            //             {
            //                 id: 31,
            //                 news_title: "持诵金刚经得定要诀"
            //             }
            //         ]
            //     },
            //     {
            //         id: 40,
            //         cate_name: "学禅有关典籍",
            //         lists: [
            //             {
            //                 id: 30,
            //                 news_title: "六祖大师法宝坛经"
            //             },
            //             {
            //                 id: 29,
            //                 news_title: "金刚经"
            //             }
            //         ]
            //     }
            // ]
        };
    },
    watch:{
        content(){
             //初始化contentStatus
            let array = [];
            let length = this.content.length;
            for(let i=0;i<length;i++){
                array[i] = false;
            }
            this.contentStatus = array;
        }
    },
    methods: {
        changShowList(index) {
            this.contentStatus.splice(index, 1, !this.contentStatus[index]);
        },
        //诗歌文章详情
        linkToArticleDetail(item) {
            this.$router.push({ path: "/articleDetail",query:{name:"ancientBooks",id:item.id,title:this.title} });
        }
    }
};
</script>

<style scoped>
.taoist {
    color: #333333;
}

.title {
    padding: 0.64rem;
}

.titleLeft {
    font-size: 0.8rem;
    line-height: 1.8rem;
    font-size: 0.85rem;
    font-weight: 600;
    width:12rem;
}

.content {
    /* height: 2.4rem; */
    border-top: 1px dashed #dfdfdf;
    line-height: 1.8rem;
    padding-left: 0.64rem;
    padding-right: 0.64rem;
    font-size: 0.85rem;
}

/* .expand {
    font-size: 0.69rem;
    width: 3.6rem;
  } */
.openBtn {
    width: 4rem;
   flex-shrink:0;
}
.down img {
    width: 0.64rem;
    height: 0.32rem;
    margin-left: 0.2rem;
}
</style>